import type { ButtonHTMLAttributes } from 'react'

import cx from 'classnames'

import styles from './grid.module.css'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement>{
  purple?: boolean
  light?: boolean
  rounded?: boolean
  primary?: boolean
}

export function Button ({ children, className, ...rest }: ButtonProps): JSX.Element {
  const classNames = cx(
    styles.button,
    {
      'bg-primary bg-opacity-90 px-8 text-white hover:bg-opacity-100 transition-colors': rest.primary && !rest.light && !rest.rounded,
      'border border-solid border-primary px-6 text-primary rounded-full transition-colors': rest.primary && rest.rounded,
      'text-primary text-opacity-90 px-8 hover:text-opacity-100 transition-colors': rest.primary && rest.light && !rest.rounded,
      'bg-purple-600 px-10 text-white hover:bg-purple-700 transition-colors': rest.purple && !rest.light,
      'text-purple-600 px-10 hover:text-purple-700 transition-colors': rest.purple && rest.light,
      [styles.light as string]: rest.light,
      [styles.rounded as string]: rest.rounded && !rest.primary
    },
    className
  )

  return (
    <button
      className={classNames}
      {...rest}
    >
      {children}
    </button>
  )
}
